import styled from 'styled-components/macro';

export const Wrapper = styled.div``;
